module.exports = __webpack_public_path__ + "static/media/thought.22742995.svg";